// extracted by mini-css-extract-plugin
export default {"resume_section":"Resume_resume_section__jFY-o","container":"Resume_container__aka-E","heading":"Resume_heading__5UylM","title":"Resume_title__p2S55"};